import React from "react";
import "../styles/Notfoundz404.css";
import Header from "./Header";
import Navbar from "./Navbar";
import drpLogo from "../images/DRP12.png";
import Footer from "./Footer";

const NotFound404 = () => {
  return (
    <>
      <Header />
      <Navbar />
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>

          <img src={drpLogo} alt="DRP Logo" className="not-found-logo" />

          <p className="not-found-company">
            SAARDRP International Ventures Pvt Ltd
          </p>
          <p className="not-found-message">Oops! Page not found.</p>
          <p className="not-found-description">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <a href="/" className="not-found-button">
            Go Back Home
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound404;
